import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js";
import { alarm_list, merchant_del, get_merchant_all, get_downloadtoken } from "@/api/jingxiaoshang";
import addCom from "./components/addCom";
import handleCom from "./components/handleCom";
import { getcurrDate } from "@/libs/util";
import { commonReq } from "@/api/common.js";
import axios from "axios";
import config from "@/config/index";
import downloadHistory from "../../../console/deviceman/devicedistribution/components/downloadHistory.vue"; // import viewVideo from './components/viewVideo'

export default {
  name: "project",
  mixins: [packageTableMixins],
  data: function data() {
    return {
      merchantData: [],
      showVideoModal: false,
      //模拟数据列表
      switchList: {},
      merchant_list: [],
      statuslist: [{
        name: this.$t("alarmmenu.nothandle"),
        value: 1
      }, {
        name: this.$t("alarmmenu.okhandle"),
        value: 2
      }],
      //共用的查询与重置
      statusData3: [{
        value: "xciot-prod-cnsz",
        name: this.$t("Changelang.中国")
      }, {
        value: "xciot-prod-hk",
        name: this.$t("Changelang.香港")
      }, {
        value: "xciot-prod-us2",
        name: this.$t("美国")
      }, {
        value: "xciot-prod-eu",
        name: this.$t("Changelang.欧洲")
      }],
      topButtonList: [{
        name: this.$t("query"),
        type: "primary",
        method: this.search
      }, {
        name: this.$t("reset"),
        type: "error",
        method: this.reset
      }],
      ids: [],
      parent_name: null,
      editData: null,
      editModal: false,
      modalTitle: "新增",
      parent_code: null,
      reduceheight: 78,
      showAddModal: false,
      showHandleModal: false,
      headBtnList: [{
        name: "查询",
        type: "primary",
        method: this.search
      }, {
        name: "重置",
        type: "error",
        method: this.reset
      }],
      headBtnList1: [{
        name: this.$t("export"),
        icon: "ios-download",
        type: "primary",
        method: this.export
      }],
      moduleData: [],
      //模块
      stateData: [{
        value: -1,
        label: "全部"
      }, {
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      form_filter: {
        // merchant_code:null,
        // status: null,
        // alarm_level:null
        did: null,
        date: null,
        start_time: null,
        end_time: null,
        country_code: "xciot-prod-cnsz"
      },
      searchReq: {
        mods: []
      },
      tableData: [],
      columnsData: [// {
      //   title: '多选',
      // //  key: 'id',
      //   align: 'center',
      //   width: 100,
      //   type: 'selection'
      // },
      // {
      //   title: '序号',
      //   key: 'id',
      //   align: 'center',
      //   width:100
      // },
      {
        title: this.$t("alarmmenu.did"),
        key: "device_id",
        align: "center"
      }, {
        title: this.$t("alarmmenu.affiliatedagent"),
        key: "shop_name",
        align: "center"
      }, {
        title: this.$t("alarmmenu.datatype"),
        key: "data_type_name",
        align: "center"
      }, {
        title: this.$t("alarmmenu.address"),
        key: "addr_name",
        align: "center"
      }, {
        title: this.$t("alarmmenu.alarmcause"),
        key: "alarm_type_name",
        align: "center"
      }, {
        title: this.$t("alarmmenu.alarmtime"),
        key: "alarm_time",
        align: "center"
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: ""
      },
      reqBase: {
        page: 1,
        type: 1
      },
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }]
    };
  },
  props: {
    hasDid: {}
  },
  components: {
    addCom: addCom,
    handleCom: handleCom
  },
  computed: {},
  methods: {
    export: function _export(row) {
      var _this2 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, vm.$t("exportTime")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(downloadHistory, {
            ref: "downloadHistory",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this2.code,
              dids: _this2.dids
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.downloadHistory;
          obj.checkForm().then(function (req) {
            if (vm.form_filter.did) {
              if (req) {
                var formModel = obj.formModel;
                var domain = vm.get_domain();
                var lang = localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
                get_downloadtoken({
                  type: "2",
                  country_code: vm.form_filter.country_code
                }).then(function (res) {
                  _this.buttonLoading = false;

                  if (res.result === 0) {
                    var downloadtoken = res.body.downloadtoken;
                    var params = "?type=2&downloadtoken=" + downloadtoken + "&did=" + vm.form_filter.did + "&time_start=" + formModel.start_time + "&time_end=" + formModel.end_time + "&lang=" + lang;
                    console.log(domain + "/index.php/admin/device/history_daochu" + params);
                    window.open(domain + "/index.php/admin/device/history_daochu" + params);
                    vm.$Modal.remove();
                  } else {
                    vm.$Message.error(res.errorMsg);
                  }
                });
              } else {
                _this.buttonLoading = false;
              }
            } else {
              _this.$Message.error(vm.$t("请选择导出设备") + "ID");

              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_domain: function get_domain() {
      var result = "";
      var country_code = localStorage.getItem("country_code");
      result = country_code === "xciot-prod-cnsz" ? "https://bms-api.xcthings.com" : country_code === "xciot-prod-hk" ? "https://bms-hk-api.xcthings.com" : country_code === "xciot-prod-us2" ? "https://bms-us-api.xcthings.com" : "https://bms-eu-api.xcthings.com";
      return result;
    },
    changeTime: function changeTime(val) {
      this.$set(this.form_filter, "date", val);
    },
    getMerchantData: function getMerchantData() {
      var _this3 = this;

      console.log(111);
      this.merchantData.splice(0);
      get_merchant_all().then(function (res) {
        if (res.result === 0) {
          console.log(data);
          var data = res.body;

          _this3.checkTree(data); // console.log('a',data)


          _this3.merchantData = data;
        }
      });
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        if (arr[i].shop_name) {
          arr[i].value = arr[i].merchant_code;
          arr[i].label = arr[i].shop_name;
          arr[i].title = arr[i].shop_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }

        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          var _arr$i$children;

          (_arr$i$children = arr[i].children).push.apply(_arr$i$children, _toConsumableArray(arr[i].children_shop));
        }

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    changeSwitch: function changeSwitch(val, id, index) {
      console.log(val);

      if (this.switchList.hasOwnProperty(id)) {
        this.$set(this.switchList[id], index, val);
      } else {
        this.$set(this.switchList, id, {});
        this.$set(this.switchList[id], index, val);
      }

      localStorage.setItem("switchList", JSON.stringify(this.switchList));
    },
    idSelectChange: function idSelectChange(SelectItem) {
      this.ids.splice(0);

      if (SelectItem && SelectItem.length > 0) {
        for (var i in SelectItem) {
          var list = SelectItem[i];
          this.ids.push(list.id); // this.ids = list.id
        }
      }

      console.log(this.ids);
    },
    reset: function reset() {
      this.form_filter = {
        did: null,
        date: null,
        start_time: null,
        end_time: null,
        country_code: "xciot-prod-cnsz"
      };
      this.form_filter.type = "";
      this.search();
    },
    search: function search() {
      this.form_filter.type = "";
      console.log("this.form_filter", this.form_filter);
      this.onSearch(this.form_filter);
    },
    onSearch: function onSearch(params) {
      //重置当前页为1
      this.reqBase.page = 1;
      this.reqBase.time_end = "";
      this.reqBase.time_start = "";
      Object.assign(this.reqBase, params); //重置当前的page
      //this.$refs.contentBaseRef.initcurrentPage();

      this.init();
    },
    init: function init() {
      localStorage.setItem("country_code", this.form_filter.country_code);

      if (this.form_filter.date == "") {
        this.form_filter.date = getcurrDate();
        this.reqBase.date = this.form_filter.date;
      }

      if (this.$route.query.did) {
        this.form_filter.did = this.$route.query.did;
        this.reqBase.did = this.$route.query.did;
      } // debugger
      // this.getMerchantData();


      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 初始化数据
     */
    getData: function getData() {
      var _this4 = this;

      this.reqBase.date = this.form_filter.date;
      this.tableLoading = true;
      var vm = this; //;

      var callbak = function callbak(res) {
        _this4.tableLoading = false;

        if (res.result === 0) {
          vm.tableData = res.body.list || [];
          var len = vm.tableData.length;

          if ("type" in _this4.reqBase && _this4.reqBase.type != "") {
            console.log("yes");
            var prev_pages = localStorage.getItem("prev_time");
            var prev_pages2 = JSON.parse(prev_pages);
            prev_pages2.push(vm.tableData[len - 1].time);
            localStorage.setItem("prev_time", JSON.stringify(prev_pages2));
          } else {
            var _prev_pages = [];

            _prev_pages.push(0);

            _prev_pages.push(vm.tableData[len - 1].time);

            localStorage.setItem("prev_time", JSON.stringify(_prev_pages));
          }

          localStorage.setItem("time_end", vm.tableData[len - 1].time);
          vm.tabletotallen = res.body.total;
        } else {
          if (res.errorMsg == "数据为空") {
            _this4.$Message.error(res.errorMsg);

            return;
          }

          vm.tableData = [];

          _this4.$Message.error(res.errorMsg);
        }
      };

      var state = this.reqBase.state;

      if (this.reqBase.state === -1) {
        state = "";
      }

      var mod_code = this.reqBase.mod_code;

      if (this.reqBase.mod_code == -1) {
        mod_code = "";
      }

      console.log("我的查询条件", _objectSpread({}, this.reqBase, {
        state: state,
        mod_code: mod_code
      })); // return;

      commonReq("/index.php/admin/alarm/new_alarm_list", _objectSpread({}, this.reqBase, {
        state: state,
        mod_code: mod_code
      })).then(function (res) {
        callbak(res);
      }).catch(function (err) {
        _this4.tableLoading = false;
      }); // //商户列表
      // merchant_list({
      //               page: 1,
      //               page_size: 100000000,
      //               type: localStorage.getItem('account_type')
      //             }).then(res => {
      //               if(res.result===0){
      //                 this.merchant_list = res.body.list || [];
      //                  console.log(res.body.list)
      //                 //this.$parent.init()
      //                 //this.handleReset(this.formName)
      //                 //this.onCancel()
      //               }else{
      //                 this.$Message.error(res.errorMsg)
      //                 this.backStatus()
      //               }
      //             }).catch(()=>{
      //               this.backStatus()
      //             })
    },

    /**
     * 重置搜索框
     */
    resetSearch: function resetSearch() {
      this.searchReq = {
        mods: []
      };
    },
    okSearch: function okSearch() {
      Object.assign(this.reqBase, this.searchReq); //重置当前页为1

      this.reqBase.page = 1;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },

    /**
     * 控制模态框显示隐藏
     * type 显示隐藏
     * handle true新增 false编辑
     * row 本条数据
     */
    addModuleShow: function addModuleShow() {
      this.modalTitle = this.$t("alarmmenu.batchprocessing");
      this.parent_code = "";
      this.parent_name = this.$t("alarmmenu.nodata");
      this.editModal = false;
      this.ids = this.ids;
      this.showAddModal = !this.showAddModal;
    },
    handleModuleShow: function handleModuleShow(row) {
      this.modalTitle = this.$t("alarmmenu.alarmhandle"); //'告警处理'

      this.parent_code = "";
      this.parent_name = this.$t("alarmmenu.nodata");
      this.editModal = true;
      this.editData = row;
      this.showHandleModal = !this.showHandleModal;
    },
    addChild: function addChild(row) {
      this.modalTitle = this.$t("alarmmenu.handle");
      this.editModal = false;
      this.parent_code = row.area_code;
      this.parent_name = row.area_name;
      this.showAddModal = !this.showAddModal;
    },
    edit: function edit(row) {
      this.editData = row;
      this.showVideoModal = !this.showVideoModal;
    },

    /**
     * 删除
     */
    delModule: function delModule(row) {
      var _this5 = this;

      var _this = this;

      var config = {
        loading: true,
        title: "删除",
        width: 400,
        content: "<p>\u786E\u8BA4\u5220\u9664<span style=\"color: #f60;\">".concat(row.area_name, "</span>\uFF1F</p>"),
        onOk: function onOk() {
          var params = {
            merchant_code: row.merchant_code
          },
              callbak = function callbak(req) {
            if (req.result === 0) {
              _this5.$Message.success(_this5.$t("删除成功！"));

              _this5.$Modal.remove();

              _this5.init();
            } else {
              _this5.buttonLoading = false;

              _this5.$Message.error(req.errorMsg);
            }
          }; //删除接口


          merchant_del(params).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _this6 = this;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.$route.query && this.$route.query.did) {
                this.form_filter.did = this.$route.query.did;
                this.reqBase.did = this.$route.query.did;
              }

              window.onresize = function () {//  this.changeTableHeight()
              };

              this.$nextTick(function () {
                var innerWidth = window.innerHeight - 66;
                _this6.treeHeight = innerWidth; // this.changeTableHeight()
                //显示标记的数据
                // let switchList=localStorage.getItem('switchList')
                //  if(switchList){
                //    this.$set(this,'switchList',JSON.parse(switchList))
                // }
              });
              this.init();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  created: function created() {
    this.form_filter.date = getcurrDate();
  },
  destroyed: function destroyed() {
    window.onresize = null;
  }
};